import { SET_COUNTERS } from '../constants';

export const setCounters = (data) => {
  return {
    type: SET_COUNTERS,
    data: data,
  };
};
